import styled from 'styled-components';

export const CreativesTableWrapperV2 = styled.div`
  margin: 20px;
  padding: 0 10px 0 10px;
  background-color: white;
  border-radius: 10px;
  height: 80vh;
`;
